import React, { Component } from "react";
import { apiCall_domain } from "../api";
import axios from "axios";
import Spinner from "../Spinner/Spinner";

class InstallmentImgUpload extends Component {
  state = {
    slots: [],
    loading: true,
    item: "",
    images: [],
    uploadedImages: [],
    error: "",
  };

  componentDidMount() {
    const Headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/contracts/slots/${this.props.orderBy}`, {
        headers: Headers,
      })
      .then((res) => {
        this.setState({ slots: res.data.data, loading: false }, () => {});
      });
  }

  handleImageAdd = (e, id) => {
    const isAvailable = this.state.images.find((image) => id == image.id);
    if (!isAvailable) {
      this.setState({
        images: [
          ...this.state.images,
          {
            id: id,
            is_required: 1,
            name: e.target.name,
            file: e.target.files[0],
          },
        ],
      });
    } else {
      const otherImages = this.state.images.filter((images) => images.id != id);
      this.setState({
        images: [
          ...otherImages,
          {
            id: id,
            is_required: 1,
            name: e.target.name,
            file: e.target.files[0],
          },
        ],
      });
    }
  };

  uploadFile = (file) => {
    let formData = new FormData();
    formData.append("file", file);
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
    };
    return axios.post(`${apiCall_domain}/customer/store-file`, formData, {
      headers: headers,
    });
  };

  submit = () => {
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };

    const Data = {
      address_id: this.state.selectedAddress,
      date: "",
      delivery_type: "",
      depot_id: "",
      dev_type: "",
      discount_code: "",
      vendor_id: this.props.vendor_id,
      pay_bank: "",
      shipping: "",
      text: "",
      time_id: "",
      chassis_number: "",
      national_id: "",
      plaque: "",
      is_major: "",
      time: "",
      contract_id: this.props.organId,
      is_installment: 1,
      pay_type: 0,
      installment_info: [],
      month: this.props.selectedMonth.value,
      items: [
        {
          id: this.props.vendor_item_id,
          count: 1,
          install_need: 1,
          is_installment: 1,
        },
      ],
    };
    if (this.state.images.length == this.state.slots.length) {
      this.setState({ error: "" });
      this.uploadedImages()
        .then((res) => {
          Data["installment_info"] = this.state.uploadedImages;
          axios
            .post(`${apiCall_domain}/customer/orders/submit`, Data, {
              headers: headers,
            })
            .then((res) => {
              this.props.history.push({
                pathname: `/mainPage`,
              });
            });
        })
        .catch((err) => {});
    } else {
      this.setState({ error: "عکس های مورد نیاز را اپلود کنید" });
    }
  };
  imageShow = (id) => {
    for (const item of this.state.images) {
      if (item.id === id) {
        let binaryData = [item.file];
        let foo = URL.createObjectURL(
          new Blob(binaryData, { type: "image/png" })
        );
        return <img src={foo} />;
      }
    }
    return false;
  };

  uploadToServer = (image, resolve) => {
    this.uploadFile(image.file).then((res) => {
      if (res.data.success) {
        this.setState({
          error: "",
          uploadedImages: [
            ...this.state.uploadedImages,
            {
              image: res.data.url,
              file: res.data.name,
              name: image.name,
              id: image.id,
              uploadName: res.data.name,
            },
          ],
        });
        if (this.state.images.length == this.state.uploadedImages.length) {
          resolve();
        }
      } else {
        this.setState({ error: "عکس اپلود نشد" });
      }
    });
  };

  uploadedImages = () => {
    const haveAccess = this.state.images.find(
      (image) => image.file.size / 1024 > 1024
    );
    return new Promise((resolve, reject) => {
      if (haveAccess === undefined) {
        for (let image of this.state.images) {
          if (this.state.images.length == this.state.slots.length) {
            this.setError();
            if (image.file.size / 1024 < 1024) {
              this.setError();
              this.uploadToServer(image, resolve);
            } else {
              this.setState({
                error: "سایز فایل آپلودی بیشتر از ۱۰۲۴ کیلوبایت است",
              });
            }
          } else {
            this.setState({ error: "عکس های مورد نیاز را اپلود کنید" });
          }
        }
      } else {
        this.setState({
          error: "سایز فایل آپلودی بیشتر از ۱۰۲۴ کیلوبایت است",
        });
      }
    });
  };
  setError = () => {
    this.setState({ error: "" });
  };
  render() {
    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <div className="uploadFile">
              <div className="uploadTitle">لطفا مدارک زیر را آپلود کنید.</div>
              <div className="uploadedImgSec">
                {this.state.slots.map((item, index) => (
                  <div className={`uploadItems`}>
                    <div className="uploadItemTitle">{item.name}</div>
                    <div className="box">
                      <input
                        name="images"
                        type="file"
                        className="imgBox"
                        onChange={(e) => this.handleImageAdd(e, item.id)}
                      />
                      {this.imageShow(item.id) ? (
                        this.state.images.length ? (
                          <div className="imageShowerInstallment">
                            {this.imageShow(item.id)}
                          </div>
                        ) : null
                      ) : (
                        <div className="uploadImageText">
                          <i className="icon-plus" />
                          <span>اپلود عکس</span>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              {this.state.error ? (
                <div>
                  <span className="installmentError danger">
                    {this.state.error}
                  </span>
                </div>
              ) : null}
              <div className="buttons">
                <div className="editDoc" onClick={this.submit}>
                  ارسال
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}
export default InstallmentImgUpload;
